<template>
  <bootstrap-collapse :visible="visible">
    <b-card-text>
      <b-card-title class="h3 mb-0">Filtrar resultados</b-card-title>
      <!-- <div class="col-lg-12" style="text-align: right;"></div>
      <small class="text-muted">Defina um ou mais valores para cada filtro</small> -->

      <b-row>
        <b-col id="selectCategorie" md="6">
          <div class=" pt-3 pb-2">Categoria de entrada financeira:</div>
          <multiselect v-model="selectedInputCategories" :options="inputCategories" :searchable="true" :multiple="true" 
            placeholder="Pesquisar..." deselect-label="Remover" select-label="Adicionar" selected-label="Selecionado">
          </multiselect>
        </b-col>

        <b-col id="selectOutputCategorie" md="6">
          <div class="pt-3 pb-2">Centro de custo:</div>
          <multiselect v-model="selectedOutputCategories" :options="outputCategories" :searchable="true" :multiple="true" 
            placeholder="Pesquisar..." deselect-label="Remover" select-label="Adicionar" selected-label="Selecionado"></multiselect>
        </b-col>
      </b-row>

      <b-row>
        <b-col id="selectedClients" md="6">
          <div class="pt-3 pb-2">Cliente:</div>
          <multiselect v-model="selectedClients" :options="clients" :searchable="true" :multiple="true" 
            placeholder="Pesquisar..." deselect-label="Remover" select-label="Adicionar" selected-label="Selecionado"></multiselect>
        </b-col>

        <b-col id="selectedAgents" md="6">
          <div class="pt-3 pb-2">Fornecedor:</div>
          <multiselect v-model="selectedAgents" :options="agents" :searchable="true" :multiple="true" 
            placeholder="Pesquisar..." deselect-label="Remover" select-label="Adicionar" selected-label="Selecionado"></multiselect>
        </b-col>
      </b-row>
    </b-card-text>
  </bootstrap-collapse>
</template>

<script>
import BootstrapCollapse from "@/components/BootstrapCollapse/BootstrapCollapse";
import { Select, Option, Col } from "element-ui";
import Multiselect from 'vue-multiselect'
import { mapGetters } from "vuex";

export default {
  name: "SearchFilter",

  props: {
    visible: {
      type: Boolean,
      default: true
    },

    inputCategories: {
      type: Array,
      default: () => []
    },

    outputCategories: {
      type: Array,
      default: () => []
    },

    agents: {
      type: Array,
      default: () => []
    },

    clients: {
      type: Array,
      default: () => []
    },
  },

  components: {
    Multiselect,
    BootstrapCollapse,
    [Select.name]: Select,
    [Option.name]: Option,
    [Col.name]: Col
  },

  watch: {
    selectedInputCategories(newValue, oldValue) { this.$emit('categoriesSelected', Object.values(newValue)) },

    selectedOutputCategories(newValue, oldValue) { this.$emit('outCategoriesSelected', Object.values(newValue)) },

    selectedClients(newValue, oldValue) { this.$emit('clientsSelected', Object.values(newValue)) },

    selectedAgents(newValue, oldValue) { this.$emit('agentsSelected', Object.values(newValue)) },

  },
  data() {
    return {
      selectedInputCategories: [],
      selectedOutputCategories: [],
      selectedClients: [],
      selectedAgents: [],
    };
  },

  computed: {
    ...mapGetters([
      "params"
    ]),

  },

  methods: {
  }

};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
